import React, { ReactElement, useEffect, useMemo } from 'react';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import { DataCollectionValues, useDataCollection } from '../../../../../hooks';
import { Form } from 'formik';
import FormControl from '../../../../components/Form/FormControl';
import StepHeader from '../../../../components/Layout/StepHeader';
import InfoCard from '../../../../components/Layout/InfoCard';
import { TextsStepEnergyLossPENB } from '../../../../../data/dictionary';

interface FormError {
    lossByVentilation?: string;
    lossByInfiltration?: string;
    lossSummary?: string;
}

const stepValidation = (values: DataCollectionValues) => {
    const errors: FormError = {};

    if (!values.lossByVentilation || Number(values.lossByVentilation) < 0) {
        errors.lossByVentilation = 'Povinné pole';
    }

    if (!values.lossByInfiltration || Number(values.lossByInfiltration) < 0) {
        errors.lossByInfiltration = 'Povinné pole';
    }

    if (!values.lossSummary || Number(values.lossSummary) < 0) {
        errors.lossSummary = 'Povinné pole';
    }

    return errors;
};

const StepEnergyLossPENB = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    const errors = useMemo(() => stepValidation(values), [values]);
    useEffect(() => {
        completeStep && completeStep(!Object.keys(errors).length);
    }, [errors]);

    return (
        <Form>
            <StepHeader title="Ztráty energie" subtitle="Vyplňte prosím hodnotu z průkazu Vaší budovy" />
            <InfoCard img="ztrata-energie.jpg" texts={TextsStepEnergyLossPENB} />
            <div className="otz-house-info">
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Větrání</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="lossByVentilation"
                                    id="lossByVentilation"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.lossByVentilation}
                                    error={errors.lossByVentilation}
                                />
                                <div className="wiz-form-text">MWh/rok</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Netěsnosti obálky - infiltrace</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="lossByInfiltration"
                                    id="lossByInfiltration"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.lossByInfiltration}
                                    error={errors.lossByInfiltration}
                                />
                                <div className="wiz-form-text">MWh/rok</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="otz-house-info__item">
                    <div className="otz-house-info__inner">
                        <div className="otz-house-info__title-small">Celkem</div>
                        <div className="otz-house-info__select">
                            <div className="form-container form-container--text">
                                <FormControl
                                    name="lossSummary"
                                    id="lossSummary"
                                    type="number"
                                    tag="input"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.lossSummary}
                                    error={errors.lossSummary}
                                />
                                <div className="wiz-form-text">MWh/rok</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepEnergyLossPENB;
